import TWEEN from "three/addons/libs/tween.module.js";

/**
 * @typedef {Position} Position
 * @property {number} y
 */

export class DeskTween {
    /**
     * ms/unit
     *
     * @type {number}
     * @private
     */
    speed = 250;

    /**
     * @type {Tween}
     * @private
     */
    tween;

    /**
     * @type {Position}
     * @private
     */
    position;

    /**
     * @type {Position}
     * @private
     */
    targetPosition;

    /**
     * @param {Position} position
     */
    constructor(
        position,
    ) {
        this.targetPosition = structuredClone(position);
        this.position = position;
        this.tween = new TWEEN
            .Tween(this.position)
            .dynamic(true)
            .to(this.targetPosition);
    }

    /**
     * @param {number} height
     */
    updateHeight(height) {
        const previousHeight = this.position.y;
        const time = Math.abs(height - previousHeight) * this.speed;

        this.targetPosition.y = height;
        this.tween
            .duration(time)
            .stop()
            .startFromCurrentValues()

        // console.log('DeskTween updateHeight', {
        //     time,
        //     position: this.position.y,
        //     targetPosition: this.targetPosition.y,
        // })
    }
}
